import { render } from "./UserTrades.vue?vue&type=template&id=79400594&scoped=true"
import script from "./UserTrades.vue?vue&type=script&lang=js"
export * from "./UserTrades.vue?vue&type=script&lang=js"

import "./UserTrades.vue?vue&type=style&index=0&id=79400594&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79400594"]])

export default __exports__